import * as React from "react";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";
import { TitleRoute } from "../../Common/Routing/TitleRoute";

const OrdersInvoices = React.lazy(() => import("./OrdersInvoices"));
const OrderCreate = React.lazy(() => import("./OrderCreate/OrderCreate.tsx"));
const OrderView = React.lazy(() => import("./OrderView/OrderView"));
const OrderEdit = React.lazy(() => import("./OrderEdit"));
const OrderReview = React.lazy(() => import("./OrderReview/OrderReview"));

export default function OrdersInvoicesIndex(): React.ReactNode {
    return [
        <PermissionRoute
            permissions={[ "see_stock_management" ]}
            title="Orders | Shopfront"
            path="/orders"
            key="orders-invoices"
            element={<OrdersInvoices />}
        />,
        <PermissionRoute
            oneOf
            permissions={[
                "stock_create_order",
                "stock_create_transfer",
                "stock_create_return",
                "stock_create_credit",
            ]}
            title="Create Order | Shopfront"
            path="/order/create/:type"
            key="order-create-with-type"
            element={<OrderCreate />}
        />,
        <PermissionRoute
            oneOf
            permissions={[
                "stock_create_order",
                "stock_create_transfer",
                "stock_create_return",
                "stock_create_credit",
            ]}
            title="Create Order | Shopfront"
            path="/order/create"
            key="order-create"
            element={<OrderCreate />}
        />,
        <PermissionRoute
            permissions={[ "see_stock_management" ]}
            title="View Order | Shopfront"
            path="/order/:id"
            key="order-view"
            element={<InjectRouteParams route={OrderView} />}
        />,
        // Intentionally not using a permission route to prevent loss of data, OrderEdit will take care of it
        <TitleRoute
            title="Edit Order | Shopfront"
            path="/order/:id/edit"
            key="order-edit"
            element={<OrderEdit />}
        />,
        // Intentionally not using a permission route for the review as it's slightly complicated, OrderReview will take
        // care of it
        <TitleRoute
            title="Review Order | Shopfront"
            path="/order/:order/review/:review"
            key="order-review"
            element={<OrderReview />}
        />,
    ];
}
